import { format } from "@hejdoktor/resx-compiler"
const pluralRules = new Intl.PluralRules("no")

export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CallIssueCamera": "Det er problemer med å få tilgang til kameraet.",
	"CallIssueMicrophone": "Det er problemer med å få tilgang til mikrofonen din.",
	"CallIssueNetwork": "Det er problemer med nettverkstilkoblingen.",
	"CallIssueReconnectQuestion": "Vil du prøve å koble til igjen?",
	"CallIssueTitle": "Noe er galt",
	"CallQualityFeedback_Bad": "Dårligt",
	"CallQualityFeedback_Ok": "Godt!",
	"CallQualityFeedback_Title": "Hvordan fungerte videoteknikken?",
	"CallReJoinButton": "Koble",
	"Camera": "Kamera",
	"CameraOffTooltip": "Slå på kameraet",
	"CameraOnTooltip": "Slå av kameraet",
	"Close": "Luk",
	"Connected": "Forbundet",
	"Connecting": "Kobler...",
	"DeviceSelectionDropdownCameraPlaceholderChoose": "Velg kamera",
	"DeviceSelectionDropdownCameraPlaceholderEmpty": "Ingen kameraer funnet",
	"DeviceSelectionDropdownMicrophonePlaceholderChoose": "Velg mikrofonen din",
	"DeviceSelectionDropdownMicrophonePlaceholderEmpty": "Ingen mikrofon funnet",
	"DeviceSelectionDropdownSpeakerPlaceholderChoose": "Velg høyttaler",
	"DeviceSelectionDropdownSpeakerPlaceholderEmpty": "Ingen høyttalere funnet",
	"DeviceSelectionDropdownSpeakerPlaceholderSystemDefault": "Systemstandard",
	"DeviceSetupCameraPermissionDeniedHint": "For å delta på videokonsultasjonen må du gi tilgang til kameraet ditt.",
	"DeviceSetupContinue": "Bli med oss",
	"DeviceSetupDone": "Færdig",
	"DeviceSetupHelpLink": "Trenger du hjelp?",
	"DeviceSetupMicrophoneHint": "Beveger mikrofonlinjen seg når du snakker? Da er mikrofonen riktig tilkoblet.",
	"DeviceSetupMicrophonePermissionDeniedHint": "For å delta i videokonsultasjonen må du gi tilgang til mikrofonen din.",
	"DeviceSetupPermissionDeniedModalDescription": "Gi hejdoktor.dk tillatelse til å bruke kameraet og mikrofonen.",
	"DeviceSetupPermissionDeniedModalDescriptionDisclaimer": "Du kan slå av lyd og video i videosamtalen.",
	"DeviceSetupPermissionDeniedModalDescriptionReloadInstruction": "Last inn siden på nytt når du er ferdig.",
	"DeviceSetupPermissionDeniedModalTitle": "Kamera- og mikrofontilgang blokkert",
	"DeviceSetupSpeakerTest": "Spill av lyd",
	"DeviceSetupSubtitle": "Sjekk høyttalerne, mikrofonen og kamerainnstillingene. Klikk \"bli med\" når du er klar til å starte videokonsultasjonen.",
	"DeviceSetupTitle": "Delta på videokonsultasjonen",
	"DeviceSetupTitleSetupOnly": "Test innstillingene dine",
	"Disconnected": "Afbrudt",
	"Disconnecting": "Avbryter",
	"DoYouWantToEndTheCall": "Du er den siste her",
	"ErrorCallQualityFeedback": "Kan ikke lagre tilbakemeldingen din",
	"Ignore": "Ignorer",
	"LeavingCall": "Konkluderer...",
	"LocalPreviewCameraOff": "Kamera av",
	"Microphone": "Mikrofon",
	"MicrophoneOffTooltip": "Slå på mikrofonen",
	"MicrophoneOnTooltip": "Sluk mikrofon",
	"PhoneCallPopupDescription": "Du er i ferd med å ringe pasienten på telefon. Du kan fortsatt bruke video for å vurdere pasientens problem.",
	"PhoneCallPopupEndCallButtonText": "Koble fra telefonsamtaler",
	"PhoneCallPopupTitleConnected": "Telefonsamtalen pågår",
	"PhoneCallPopupTitleConnecting": "Ringer pasienten",
	"Reconnect": "Koble",
	"Reconnecting": "Prøver å koble til igjen",
	"ScreenShareOffTooltip": "Start skjermdeling",
	"ScreenShareOnTooltip": "Stopp skjermdeling",
	"Settings": "Innstillinger",
	"SettingsTooltip": "Innstillinger",
	"Speaker": "Høyttaler",
	"StartPhoneCall": "Start telefonsamtaler",
	"StartPhoneCallTooltip": "Hvis det oppstår tekniske utfordringer, kan du ringe pasienten på telefon.",
	"Starting": "Forrett",
	"VideoLoadingTooltip": "Kamera starter",
	"YouAreTheLastOneHere": "Du er den siste her",
	"WaitingForDoctor": "Venter på {0}",
	"BackToConsultations": "Tilbake til mine konsultasjoner",
	"ApproxWaitingTime": (number: number, { minimumFractionDigits = 0, maximumFractionDigits = 3 }: { minimumFractionDigits?: number, maximumFractionDigits?: number } = {}) => {
		const nf = new Intl.NumberFormat("no", { minimumFractionDigits, maximumFractionDigits })
		switch(pluralRules.select(number)) {
			case "one":
				return format("Ventetiden er ca 1 minutt.", nf.format(number))
			default:
			case "other":
				return format("Ventetiden er omtrent {0} minutter.", nf.format(number))
		}
	},
	"Excellent": "Fortreffelig",
	"Good": "Gud",
	"Bad": "Dårlig",
	"Unknown": "Ukjent",
	"Connection": "Forbindelse",
	"NetworkStatus": "Nettverksstatus",
	"WaitingForPatient": "Venter på pasienten",
	"DeviceCameraPermissionDeniedModalDescriptionFirstStep": "Lukk eksterne programmer som kan bruke kameraet ditt.",
	"DeviceCameraPermissionDeniedModalDescriptionSecondStep": "Hvis du bruker et eksternt kamera, kan du prøve å koble det fra og koble det til igjen.",
	"DeviceCameraPermissionDeniedModalDescriptionThirdStep": "Lukk og åpne nettleseren på nytt.",
	"DeviceMicrophonePermissionDeniedModalDescriptionFirstStep": "Lukk eksterne programmer som kan bruke mikrofonen din.",
	"DeviceMicrophonePermissionDeniedModalDescriptionSecondStep": "Hvis du bruker en ekstern mikrofon, kan du prøve å koble den fra og koble den til igjen.",
	"DeviceMicrophonePermissionDeniedModalDescriptionThirdStep": "Lukk og åpne nettleseren på nytt.",
	"DeviceSetupPermissionDeniedModalDescriptionFirstStep": "Lukk eksterne applikasjoner som kan bruke kameraet/mikrofonen din.",
	"DeviceSetupPermissionDeniedModalDescriptionSecondStep": "Hvis du bruker et eksternt kamera/mikrofon, kan du prøve å koble det fra og koble det til igjen.",
	"DeviceSetupPermissionDeniedModalDescriptionThirdStep": "Lukk og åpne nettleseren på nytt.",
	"DeviceCameraPermissionDeniedModalDescription": "Gi hejdoktor.dk tillatelse til å bruke kameraet.",
	"DeviceMicrophonePermissionDeniedModalDescription": "Gi hejdoktor.dk tillatelse til å bruke mikrofonen.",
	"DeviceCameraPermissionDeniedModalDescriptionDisclaimer": "Du kan slå av video i videosamtalen.",
	"DeviceMicrophonePermissionDeniedModalDescriptionDisclaimer": "Du kan slå av lyden i videosamtalen.",
	"DeviceCameraPermissionDeniedModalTitle": "Tilgang til kameraet er blokkert",
	"DeviceMicrophonePermissionDeniedModalTitle": "Tilgang til mikrofon er blokkert",
	"ChooseBackground": "Velg en bakgrunn",
	"AddBackground": "Legg til bakgrunn",
	"Blur": "Sløring",
	"None": "Ingen",
	"NoAnswerInfoHeader": "Kunne du ikke komme i kontakt med pasienten?",
	"NoAnswerInfoText": "Prøv først å ringe pasienten. Hvis dette ikke lykkes, send en automatisk e-post med en invitasjon til å bestille en ny avtale.",
	"Call": "Ring opp",
	"SendMail": "Send e-post",
	"EmailSent": "E-posten er sendt til pasienten",
	"ErrorSentEmail": "FEIL: Kunne ikke sende e-post til pasienten.",
	"TechnicalIssues": "Var det problemer med teknikken?",
	"EndVideo": "Avslutt video",
}